import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import BankAccountVM from './BankAccountVM';
import { observer } from 'mobx-react';
import BankAccountBalance from '../../Models/Catalogue/Investments/BankAccountBalance';
import { Validation } from '@singularsystems/neo-core';

@observer
export default class BankAccountView extends Views.ViewBase<BankAccountVM> {

    constructor(props: unknown) {
        super("Bank Account", BankAccountVM, props);
    }

    public render() {
        var viewModel = this.viewModel;

        return (
            <div className="mt-4 mb-4">
                <Neo.Card title="Edit Bank Accounts">
                    {!viewModel.editingBankAccount &&
                        <Neo.Form onSubmit={() => viewModel.searchImmediate()} showSummaryModal>
                            <div style={{ textAlign: "right" }} className="d-flex justify-content-between mb-4">
                                <Neo.Button icon="arrow-left" variant="light" onClick={() => history.back()}>Back</Neo.Button>
                                <Neo.Button onClick={() => viewModel.newBankAccount()}>Add Bank Account</Neo.Button>
                            </div>
                            <NeoGrid.Grid items={viewModel.bankAccounts}>
                                {(item, meta) => (
                                    <NeoGrid.Row>
                                        <NeoGrid.Column display={item.values.meta.bankAccountName} width="25%" />
                                        <NeoGrid.Column display={item.values.meta.bankBranchCode} width="25%" />
                                        <NeoGrid.Column display={item.values.meta.bankAccountNumber} width="25%" />
                                        <NeoGrid.Column display={item.values.meta.bankId} select={{ itemSource: viewModel.cache.banks, renderAsText: true }} width="25%" />
                                        <NeoGrid.ButtonColumn
                                            editButton={{ onClick: () => viewModel.beginEditBankAccount(item) }}
                                            deleteButton={{ onClick: () => viewModel.deleteBankAccount(item) }} />
                                    </NeoGrid.Row>
                                )}
                            </NeoGrid.Grid>
                        </Neo.Form>
                    }
                    {viewModel.editingBankAccount &&
                        <>
                            <Neo.Form model={viewModel.editingBankAccount} showSummaryModal onSubmit={() => viewModel.saveBankAccount()} validationDisplayMode={Validation.DisplayMode.Always}>
                                {(item, meta) => (
                                    <>
                                        <Neo.Button icon="arrow-left" isOutline
                                            onClick={() => viewModel.back()}>Back</Neo.Button>
                                        <Neo.Card title="Bank Account Details">
                                            <div style={{ textAlign: "right" }} className="mb-2">
                                                <Neo.Button isSubmit icon="save"
                                                    pulse={viewModel.editingBankAccount!.isDirty}
                                                    disabled={!viewModel.editingBankAccount!.isDirty}>Save Bank Account</Neo.Button>
                                            </div>
                                            <Neo.GridLayout md={3}>
                                                <Neo.FormGroupInline bind={viewModel.editingBankAccount!.values.meta.bankAccountName} />
                                                <Neo.FormGroupInline bind={viewModel.editingBankAccount!.values.meta.bankBranchCode} />
                                                <Neo.FormGroupInline bind={viewModel.editingBankAccount!.values.meta.bankAccountNumber} />
                                                <Neo.FormGroupInline bind={viewModel.editingBankAccount!.values.meta.bankId}
                                                    select={{ itemSource: viewModel.cache.banks, displayMember: "bankName", valueMember: "bankId" }} width="25%" />
                                                <Neo.FormGroupInline bind={viewModel.editingBankAccount!.values.meta.bankAccountTypeId}
                                                    select={{ itemSource: viewModel.cache.bankAccountTypes, displayMember: "bankAccountTypeName", valueMember: "bankAccountTypeId" }} />
                                            </Neo.GridLayout>
                                        </Neo.Card>
                                    </>
                                )}
                            </Neo.Form>
                            <Neo.Form model={viewModel.pageManager.data} showSummaryModal onSubmit={() => viewModel.saveBankAccountBalances()} validationDisplayMode={Validation.DisplayMode.Always}>
                                {(item, meta) => (
                                    <>
                                        <Neo.Card title="Bank Account Balances">
                                            <div style={{ textAlign: "right" }} className="mb-2">
                                                {!viewModel.addMode &&
                                                    <Neo.Button icon="save"
                                                        pulse={viewModel.pageManager.data.isDirty || viewModel.addMode}
                                                        disabled={!viewModel.pageManager.data.isDirty && !viewModel.addMode}
                                                        onClick={() => viewModel.saveBankAccountBalances()}>Save Balances</Neo.Button>}
                                            </div>
                                            {!viewModel.addMode &&
                                                <Neo.GridLayout lg={2}>
                                                    <Neo.FormGroupInline bind={viewModel.criteria.meta.startDate} />
                                                    <Neo.FormGroupInline bind={viewModel.criteria.meta.endDate} />
                                                </Neo.GridLayout>
                                            }
                                            <Neo.Pager pageManager={viewModel.pageManager} pageControls="bottom" >
                                                <NeoGrid.Grid<BankAccountBalance> addButton={{ onClick: () => this.viewModel.newBankAccountBalance() }}>
                                                    {(item, meta) => (
                                                        <NeoGrid.Row>
                                                            <NeoGrid.Column bind={meta.balanceDate} width="47%" />
                                                            <NeoGrid.Column bind={meta.balance} width="47%" />
                                                            <NeoGrid.ButtonColumn showDelete width="6%" />
                                                        </NeoGrid.Row>
                                                    )}
                                                </NeoGrid.Grid>
                                            </Neo.Pager>
                                        </Neo.Card>
                                    </>
                                )}
                            </Neo.Form>
                        </>
                    }
                </Neo.Card>
            </div>
        );
    }

    public onLeave():  string | undefined {
        if (this.viewModel.editingBankAccount?.isDirty) {
            return "Are you sure you want to leave this page without saving?";
        }
        return undefined;
    }
}